var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-provider", {
    ref: "validationProvider",
    staticClass: "_eui-form_kryssruta_validation-provider",
    attrs: {
      tag: "div",
      mode: "eagerMedBlurOchDebounce",
      rules: _vm.vpValidationRules
    },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function(ref) {
            var valid = ref.valid
            var errors = ref.errors
            var failedRules = ref.failedRules
            var flags = ref.flags
            return [
              _c(
                "div",
                {
                  staticClass: "_eui-form_kryssruta",
                  class: [
                    _vm.vpClass,
                    {
                      "-obligatorisk":
                        _vm.arRequired && !_vm.vpIndikeraInteObligatorisk,
                      "-readonly": _vm.vpReadOnly,
                      "-osynlig": _vm.skaVaraOsynlig,
                      "-invalid": flags.validated && !valid
                    }
                  ],
                  style: _vm.vpStyle
                },
                [
                  _c(
                    "input",
                    _vm._g(
                      _vm._b(
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.lazy",
                              value: _vm.innerChecked,
                              expression: "innerChecked",
                              modifiers: { lazy: true }
                            }
                          ],
                          ref: "inputelementet",
                          class: {
                            "-readonly": _vm.vpReadOnly
                          },
                          attrs: {
                            id: _vm.uniktId,
                            type: "checkbox",
                            name: _vm.uniktId + "-name",
                            title: _vm.vpTooltip,
                            autofocus: _vm.vpAutofocus,
                            disabled: _vm.skaVaraInaktiverad || _vm.vpReadOnly
                          },
                          domProps: {
                            checked: Array.isArray(_vm.innerChecked)
                              ? _vm._i(_vm.innerChecked, null) > -1
                              : _vm.innerChecked
                          },
                          on: {
                            keydown: [
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.onEnterTryckt()
                              },
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "esc",
                                    27,
                                    $event.key,
                                    ["Esc", "Escape"]
                                  )
                                ) {
                                  return null
                                }
                                return _vm.onEscTryckt()
                              }
                            ],
                            change: function($event) {
                              var $$a = _vm.innerChecked,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.innerChecked = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.innerChecked = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.innerChecked = $$c
                              }
                            }
                          }
                        },
                        "input",
                        _vm.$attrs,
                        false
                      ),
                      _vm.inputListeners
                    )
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "_eui-form_kryssruta_etikett",
                      class: {
                        "-readonly": _vm.vpReadOnly
                      },
                      attrs: { for: _vm.uniktId }
                    },
                    [
                      _vm.vpEtikett
                        ? _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.vpEtikett) }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("default"),
                      _vm._v(" "),
                      _vm.vpHjalptextHtml &&
                      !_vm.skaVaraInaktiverad &&
                      !_vm.vpReadOnly
                        ? _c(
                            "eui-hjalpknapp",
                            {
                              staticStyle: { margin: "-2em 0" },
                              attrs: {
                                "vp-unikt-id-del": _vm.uniktId,
                                "vp-color": "#0088dd"
                              }
                            },
                            [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.vpHjalptextHtml)
                                }
                              })
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "_eui-form_kryssruta_feltext" }, [
                    _c("div", {
                      staticClass: "ellipsis",
                      domProps: { innerHTML: _vm._s(errors[0]) }
                    })
                  ])
                ]
              )
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }